var map = {
	"./blackGold/header/setting.png": 70611,
	"./brownGold/header/setting.png": 69749,
	"./darkBlue/header/setting.png": 36102,
	"./greenYellow/header/setting.png": 77676,
	"./redGold/header/setting.png": 17688,
	"./skyBlue/header/setting.png": 50777,
	"./whiteGold/header/setting.png": 20171,
	"./yellowWhite/header/setting.png": 18632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41400;